<template>
  <div class="block">
    <h4>Selecciona tus filtros personalizados</h4>

    <div class="block block--light info">
      <InfoCircleOutlined class="icon" />
      <span class="info--text" action="Cerrar">
        Puedes segmentar aun más tu estrategia seleccionando los filtros personalizados que creaste
        en la sección de plantillas.
      </span>
    </div>

    <dashed-button @click="handleOpenDrawer">
      {{ filterQuantityText }}
    </dashed-button>

    <custom-filters-drawer ref="drawer" :value="visible" @update:value="visible = $event" />
  </div>
</template>

<script>
import CustomFiltersDrawer from "@/app/strategies/components/drawers/CustomFiltersDrawer.vue";
import DashedButton from "@/app/strategies/components/buttons/DashedButton.vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

export default {
  components: {
    CustomFiltersDrawer,
    DashedButton,
    InfoCircleOutlined,
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    counter() {
      return this.$store.getters["getStrategyCustomFiltersCount"];
    },
    filterQuantityText() {
      if (this.counter == 0) return "Seleccionar más filtros aquí";
      if (this.counter == 1) return `Se ha agregado un filtro, seguir editando aquí`;
      return `Se han agregado ${this.counter} filtros, seguir editando aquí`;
    },
  },
  methods: {
    handleOpenDrawer() {
      this.$refs.drawer.initDrawer();
      this.visible = true;
    },
  },
};
</script>

<style lang="sass" scoped>
.block
  padding: 28px 12px 20px 12px
  margin: 12px 0
  border: 1px solid $gray-6
  border-radius: 8px

  &--light
    border: 1px solid #dcdcdc
    color: $gray-7
    padding: 8px 12px
    margin: 4px 0 12px 0

.info
  display: flex

  &--text
    font-size: 12px

.icon
  margin: 3px 6px 0 0
</style>
